<template>
    <div>
        <spinner v-if="mismatched === null"></spinner>
        <table v-if="mismatched !== null">
            <thead>
                <tr>
                    <th>Variable</th>
                    <th>Year 1</th>
                    <th>Label 1</th>
                    <th>Year 2</th>
                    <th>Label 2</th>
                </tr>
            </thead>
            <!--<tr v-for="mismatch in variable.mismatches">-->
            <tr v-for="v in mismatched" v-bind:key="v.variable">
                <td>{{ v.variable }}</td>
                <!--<td>{{v.year}}</td>-->
                <td>{{ v.firstYears }}</td>
                <td>{{ v.secondYears }}</td>
                <td>{{ v.label1 }}</td>
                <td>{{ v.label2 }}</td>
                <!--<td>{{variable}}</td>-->
                <!--</tr>-->
            </tr>
        </table>
        <!--<div v-for="m1 in mismatchedVariables1">{{m1}}</div>
    <div v-for="m1 in mismatchedVariables2">{{m1}}</div>-->
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import current from '@/scripts/current';
import commonApiHelper from '@/scripts/commonApiHelper';
import variableValidator from '@/scripts/variableValidator';
import variableSelectionHelper from '@/scripts/variableSelectionHelper';
import spinner from '@/components/sub/spinner';
import store from '@/store';
import $ from 'jquery';

export default {
    components: {
        spinner: spinner
    },
    created: function() {
        const vm = this;
        current.initializeValidateVariables('Validate Variables');
        loadVariablesFromApi(vm);
    },
    data: function () {
        return {
            mismatched: null
        };
    },
    methods: {}
};

function loadVariablesFromApi(vmData) {
    let timeoutSeconds = 0; // No limit
    let parameters = [];
    commonApiHelper.addServiceParameters(parameters, 'brfss_p.api.sas');
    parameters.push({ queryCode: 'type', value: 'oldVariables' });
    parameters.push({ queryCode: 'output_format', value: 'json' });
    let apiFormData = commonApiHelper.toQueryString(parameters);
    store.dispatch('display/setIsLoading', true);
    $.ajax({
        url: process.env.VUE_APP_SAS_BROKER,
        type: 'POST',
        timeout: timeoutSeconds * 1000,
        data: apiFormData,
        success: function (data) {
            let variables = data.variables;
            vmData.mismatched =
                variableValidator.getAllMismatchedVariables(variables);
            store.dispatch('display/setIsLoading', false);
        },
        error: function (jqXHR) {
            store.dispatch('display/setIsLoading', false);
            console.log('API Error', jqXHR);
        }
    });
}
</script>

<style scoped>
td {
    padding: 5px 10px 5px 10px;
}

thead {
    font-weight: bold;
}
</style>
